export default {
	TitleNotification: 'Setup notifications',
	ReceiveEmailNotificationSetup: 'Receive email notification of invoice status changes',
	GuideLabel: 'Guide',
	Edit: 'Edit',
	TitleSettingNavbar: 'Display settings for the module bar',
	ReceiveSettingNavbar: 'Display settings for modules based on usage needs',
	SettingNavbarDetail: {
		Title: 'Module bar display options',
		TitleTable: 'Module list',
		dashboard: 'Dashboard',
		invoice: 'Input invoice',
		invoiceThirdParty: 'Invoice', // PBI-546507: For third-party org
		outinvoice: 'Output invoice',
		customsdeclaration: 'Customs declaration',
		inboxmanagement: 'Inbox',
		supplier: 'Category',
		organization: 'Organization structure',
		connectinvoices: 'Connect to suppliers',
		connecttaxaxions: 'Connect Tax Authority',
		report: 'Report',
		system: 'System',
		knowledge: 'Useful knowledge'
	},
	SettingFilterDate: {
		TitleSettingFilterDate: "Default date filter settings on the incoming invoice list",
		TitleSettingFilterDateThirdParty: "Default date filter settings on the invoice list", // PBI-546507: For third-party org
		SettingDate: 'By Invoice Date',
		SettingDateEenteredTheSystem: 'By Date Entered into the System',
	},
	SettingAppearance: {
		Title: 'Interface color setup',
		Description: 'Set the background color for the Sidebar and the page title bar',
		GroupTitlebar: 'Title bar color',
		GroupSidebar: 'Sidebar color',
		OptionTitlebarApp: 'App color',
		OptionTitlebarWhite: 'White',
		OptionSidebarDark: 'Dark',
		OptionSidebarWhite: 'White',
		Reset: 'Restore default'
	}
};
